"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _theme = _interopRequireDefault(require("../../theme"));
var _styledComponents = require("./styled-components");
var _Grid = _interopRequireDefault(require("../Grid"));
var _AlertError = _interopRequireDefault(require("../../icons/AlertError"));
var _AlertInfo = _interopRequireDefault(require("../../icons/AlertInfo"));
var _AlertCheckmark = _interopRequireDefault(require("../../icons/AlertCheckmark"));
var _Close = _interopRequireDefault(require("../../icons/Close"));
var _excluded = ["variant", "isIconHidden", "onClick", "testId", "text", "children"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var FlashMessage = function FlashMessage(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'success' : _ref$variant,
    _ref$isIconHidden = _ref.isIconHidden,
    isIconHidden = _ref$isIconHidden === void 0 ? false : _ref$isIconHidden,
    onClick = _ref.onClick,
    testId = _ref.testId,
    text = _ref.text,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isClosed = _useState2[0],
    setIsClosed = _useState2[1];
  var Icon = !isIconHidden && getIconVariant(variant);
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.FlashContainer, _extends({}, otherProps, {
    style: {
      backgroundColor: getColorVariant(variant),
      fontWeight: 600
    },
    "aria-hidden": isClosed,
    isClosed: isClosed,
    "data-testid": testId
  }), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    style: {
      margin: 'auto'
    }
  }, /*#__PURE__*/_react["default"].createElement(_styledComponents.InnerWrapper, null, Icon && /*#__PURE__*/_react["default"].createElement(_styledComponents.IconWrapper, null, /*#__PURE__*/_react["default"].createElement(Icon, {
    size: 30,
    color: _theme["default"].grey120
  })), /*#__PURE__*/_react["default"].createElement(_styledComponents.Content, {
    "aria-live": "assertive"
  }, text || _react["default"].Children.map(children, function (child) {
    return /*#__PURE__*/_react["default"].isValidElement(child) && child.props.href ? /*#__PURE__*/_react["default"].cloneElement(child, {
      style: {
        color: _theme["default"].grey120,
        textDecoration: 'underline'
      }
    }) : child;
  })), /*#__PURE__*/_react["default"].createElement(_styledComponents.CloseWrapper, {
    onClick: onClick ? onClick : function () {
      return setIsClosed(true);
    },
    "aria-label": "Close"
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], {
    size: 20,
    color: _theme["default"].grey120,
    "aria-hidden": "true"
  })))));
};
FlashMessage.propTypes = {
  variant: _propTypes["default"].oneOf(['success', 'info', 'warning', 'error']),
  isIconHidden: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  testId: _propTypes["default"].string,
  text: _propTypes["default"].string,
  children: _propTypes["default"].node
};
var getIconVariant = function getIconVariant(variant) {
  switch (variant) {
    case 'success':
      return _AlertCheckmark["default"];
    case 'info':
      return _AlertInfo["default"];
    case 'warning':
      return _AlertError["default"];
    case 'error':
      return _AlertError["default"];
  }
};
var getColorVariant = function getColorVariant(variant) {
  switch (variant) {
    case 'success':
      return _theme["default"].alertSuccess100;
    case 'info':
      return _theme["default"].alertInfo100;
    case 'warning':
      return _theme["default"].alertWarning100;
    case 'error':
      return _theme["default"].alertError100;
  }
};
var _default = exports["default"] = FlashMessage;